__turbopack_context__.v({
  "className": "outfit_5f24e5bf-module__bkFFia__className",
  "variable": "outfit_5f24e5bf-module__bkFFia__variable",
});
